var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      attrs: {
        action: _vm.uploadActionUrl,
        headers: _vm.headers,
        "on-error": _vm.uploadError,
        "on-success": _vm.uploadSuccess,
        "show-file-list": false,
      },
    },
    [
      _c(
        "el-button",
        { attrs: { icon: "el-icon-document-add", type: "primary" } },
        [_vm._v(" インポート' ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }